import { Injectable } from '@angular/core';
import { FolioDialogModel, FolioDialogComponent } from './folio-dialog.component';
import { FolioEnums } from 'src/app/utilities/folio-enums';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class FolioDialogService {

  private dialogData: FolioDialogModel;
  private dialogRef: MatDialogRef<FolioDialogComponent>;

  constructor(
    private dialog: MatDialog,
  ) { }

  /**
   * Expects an INPUT to be present
   */
  prompt(data: FolioDialogModel) {
    this.dialogData = data;
    this.dialogData.dialogType = FolioEnums.folioDialogType.PROMPT;
    return this.openDialog();
  }

  alert(data: FolioDialogModel) {
    this.dialogData = data;
    this.dialogData.dialogType = FolioEnums.folioDialogType.ALERT;
    return this.openDialog();
  }

  confirm(data: FolioDialogModel) {
    this.dialogData = data;
    this.dialogData.dialogType = FolioEnums.folioDialogType.CONFIRM;
    return this.openDialog();
  }

  dropdown(data: FolioDialogModel) {
    this.dialogData = data;
    this.dialogData.dialogType = FolioEnums.folioDialogType.DROP_DOWN;
    return this.openDialog();
  }

  private openDialog() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    this.dialogRef = this.dialog.open(FolioDialogComponent, {
      width: '30em',
      data: this.dialogData,
      closeOnNavigation: true,
      disableClose: this.dialogData.disableClose
    });
    this.dialogRef.afterClosed().subscribe(res => { });
    return this.dialogRef;
  }

}
